const MS_PER_SECOND = 1000
const SECONDS_PER_MINUTE = 60
const KIB = 1024

export function formatRecordingClock(ms: number): string {
	const s = Math.floor(ms / MS_PER_SECOND)
	const m = Math.floor(s / SECONDS_PER_MINUTE)
	const sec = s % SECONDS_PER_MINUTE
	return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
}

export function formatRecordingByteSize(bytes: number): string {
	if (bytes < KIB) return `${bytes} B`
	if (bytes < KIB * KIB) return `${(bytes / KIB).toFixed(1)} KB`
	return `${(bytes / (KIB * KIB)).toFixed(1)} MB`
}

export function formatRecordingRelativeTime(recordedAtMs: number): string {
	const diffS = Math.floor((Date.now() - recordedAtMs) / MS_PER_SECOND)
	if (diffS < SECONDS_PER_MINUTE) return `${diffS}s ago`
	const diffM = Math.floor(diffS / SECONDS_PER_MINUTE)
	if (diffM < SECONDS_PER_MINUTE) return `${diffM}m ago`
	const diffH = Math.floor(diffM / SECONDS_PER_MINUTE)
	return `${diffH}h ago`
}

export function buildRecordingSuggestedBasename(extension: string): string {
	const stamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5)
	return `recording-${stamp}.${extension}`
}
